import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import config from '../config';
import './AlertLinking.css';

// Radio Button Component
const RadioButton = ({ selected, onPress, label }) => (
  <button className="radio-option" onClick={onPress}>
    <div className="radio-container">
      <div className="radio-outer">
        {selected && <div className="radio-inner" />}
      </div>
      <div className="radio-label">{label}</div>
    </div>
  </button>
);

const AlertLinking = () => {
  const { id: deviceId } = useParams();
  const navigate = useNavigate();
  const [selectedMode, setSelectedMode] = useState('none');
  const [loading, setLoading] = useState(false);

  const linkOptions = [
    { id: 'all', label: 'All Devices (Network)', value: 'all' },
    { id: 'none', label: 'None (Solo)', value: 'none' },
  ];

  const handleSave = async () => {
    setLoading(true);
    try {
      if (selectedMode === 'none') {
        await handleClearLinks();
      } else if (selectedMode === 'all') {
        // Fetch all devices
        const res = await fetch(`${config.API_BASE_URL}/devices`, {
          headers: { }
        });
        const devices = await res.json();
        
        // Link current device to every other device
        for (const dev of devices) {
          if (dev.device_id !== deviceId) {
            await fetch(`${config.API_BASE_URL}/links?device_a=${deviceId}&device_b=${dev.device_id}`, {
              method: 'POST',
              headers: { }
            });
          }
        }
        alert('All devices linked successfully!');
      }
    } catch (error) {
      console.error('Error saving links:', error);
      alert('Failed to save link settings.');
    } finally {
      setLoading(false);
    }
  };

  const handleClearLinks = async () => {
    setLoading(true);
    try {
      await fetch(`${config.API_BASE_URL}/links?device_id=${deviceId}`, {
        method: 'DELETE',
        headers: { }
      });
      setSelectedMode('none');
      alert('Links cleared successfully.');
    } catch (error) {
      console.error('Error clearing links:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="linking-container">
      {/* Header */}
      <div className="linking-header">
        <button 
          className="linking-back-button" 
          onClick={() => navigate(-1)}
        >
          <span className="linking-back-icon">‹</span>
        </button>
        <div className="linking-header-title">Linking</div>
        <div className="linking-header-spacer" />
      </div>

      {/* Scrollable Content */}
      <div className="linking-scroll-view">
        <div className="linking-content-container">
          {/* Device Name */}
          <div className="linking-device-name">{deviceId || 'Global Linking'}</div>

          {/* Choose Link Mode Section */}
          <div className="linking-section-title">Choose link mode</div>

          {/* Radio Options */}
          <div className="linking-options-container">
            {linkOptions.map((option, index) => (
              <div key={option.id}>
                <RadioButton
                  selected={selectedMode === option.id}
                  onPress={() => setSelectedMode(option.id)}
                  label={option.label}
                />
                {index < linkOptions.length - 1 && <div className="linking-divider" />}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Fixed Bottom Buttons */}
      <div className="linking-bottom-container">
        <button 
          className="linking-save-button" 
          onClick={handleSave}
          disabled={loading}
          style={{ opacity: loading ? 0.5 : 1 }}
        >
          <span className="linking-save-button-text">{loading ? 'Saving...' : 'Save'}</span>
        </button>

        <button 
          className="linking-clear-button" 
          onClick={handleClearLinks}
          disabled={loading}
          style={{ opacity: loading ? 0.5 : 1 }}
        >
          <span className="linking-clear-button-text">Clear links</span>
        </button>
      </div>
    </div>
  );
};

export default AlertLinking;

